import { render, staticRenderFns } from "./RecentVehicles.vue?vue&type=template&id=5afef72a&"
import script from "./RecentVehicles.vue?vue&type=script&lang=js&"
export * from "./RecentVehicles.vue?vue&type=script&lang=js&"
import style0 from "./RecentVehicles.vue?vue&type=style&index=0&id=5afef72a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports